import React from 'react';
import { Box, Text, Button, VStack, Container } from '@chakra-ui/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          bg="gray.50"
          minH="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={4}
        >
          <Container maxW="md">
            <Box
              bg="white"
              borderRadius="20px"
              p={10}
              shadow="xl"
              border="1px solid"
              borderColor="gray.200"
              textAlign="center"
            >
              <VStack spacing={6}>
                <Text fontSize="xl" fontWeight="bold" color="red.500">
                  Something went wrong
                </Text>
                <Text color="gray.600">
                  We're sorry, but there was an error loading this page.
                </Text>
                <Text fontSize="sm" color="gray.500">
                  Error: {this.state.error?.message}
                </Text>
                <Button
                  colorScheme="blue"
                  onClick={() => window.location.reload()}
                >
                  Reload Page
                </Button>
              </VStack>
            </Box>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 